import React, { useCallback, useEffect, useState } from 'react'

import MainModal from './common/MainModal'
import {
  SwitchHorseHeader,
  SelectRiderClass,
  SelectNewHorse,
  SetTeamMembers,
  INewMembers,
  THandlerMemberType,
} from './components/switchHorse'
import ViewsLoader from '../loader/ViewsLoader'
import { Confirm } from './components/switchHorse/Confirm'

import FirestoreService from '../../services/firestoreService'

import { getConvertedData } from '../../models/interface.helper'
import useToasterHelper from '../../helpers/ToasterHelper'
import { getUserFullName } from '../../helpers/helpers'
import { getFilteredPaperwork, saveUserDocuments } from '../../helpers/documents'
import { getAllRegistrationFees } from '../../helpers/registrationFees'

import useTeamMembers from '../../hooks/useTeamMembers'

import UserService from '../../services/firebase-service/users/userService'
import RiderTeamMemberService from '../../services/firebase-service/rider-team-member/RiderTeamMemberService'

import { EventReviewPublishModel } from '../../models/event-review-publish/event-review-publish.model'
import { HorseModel } from '../../models/horse/horse.model'
import { RiderTeamMemberModel } from '../../models/rider-team-member/riderTeamMember.model'

import { IUserPublicInterface } from '../../models/users-public/users-public.interface'
import { IRider } from '../../types/entryRider'
import { IEventReviewPublish } from '../../models/event-review-publish/event-review-publish.interface'
import { RegistrationFeesType } from '../../models/event-fees/event-fees.interface'
import { IHorseData } from '../../models/horse/horse.interface'
import { IOption } from '../inputs/InputNewMemberRow'
import { IRegistrationByDayInterface } from '../../models/registrations-by-day/registrationByDay.interface'
import { IRiderTeamMemberInterface } from '../../models/rider-team-member/riderTeamMember.interface'

import { signedStatuses } from '../../const/data/v01/rider-team-members/firestore-v01-rider-team-member-const'

import { MODAL_CONSTS } from '../../const/modal-const'
import { CONST } from '../../const/const'
import { MESSAGES_CONST } from '../../const/messages-const'

const TEAM_MEMBER_ROLES = CONST.UI.TEAM_MEMBERS_ROLES

const ROLES = Object.values(TEAM_MEMBER_ROLES)
  .filter((role) => role !== TEAM_MEMBER_ROLES.RIDER)
  .map((value) => ({
    value,
    label: value,
  }))

type IProps = {
  show: boolean
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
  dataToPassOn: {
    rider: IRider
    onSwitchHorse: (registrationsByDayUpdated: IRegistrationByDayInterface[]) => void
  }
}

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

enum EScreens {
  loader,
  entry,
  horse,
  teamMember,
  confirm,
}

export const SwitchHorse: React.FC<IProps> = (props) => {
  const { saveRidersTeamMembers } = useTeamMembers()

  const [step, setStep] = useState<EScreens>(EScreens.loader)
  const [loading, setLoading] = useState(false)
  const [eventData, setEventData] = useState<IEventReviewPublish | null>(null)
  const [entries, setEntries] = useState<RegistrationFeesType[]>([])
  const [selectedEntries, setSelectedEntries] = useState<RegistrationFeesType[]>([])
  const toastFunctions = useToasterHelper()
  const [isBtnNextDisabled, setIsBtnNextDisabled] = useState(true)
  const [horses, setHorses] = useState<IHorseData[]>([])
  const [newHorse, setNewHorse] = useState<IHorseData | null>(null)
  const [selectedRiderMultiHorse, setSelectedRiderMultiHorse] = useState<IHorseData | null>(null)
  const [isMultiHorseShown, setIsMultiHorseShown] = useState(false)
  const [exibitor, setExibitor] = useState<IUserPublicInterface | null>(null)
  const [newMembers, setNewMembers] = useState<INewMembers[]>([])

  const { rider, onSwitchHorse } = props.dataToPassOn
  const isMultiHorse = (rider.horsesSelected || []).length > 1
  const isMultiClasses = (rider.classes || []).length > 1

  useEffect(() => {
    setIsMultiHorseShown(isMultiHorse || false)
  }, [rider])

  useEffect(() => {
    ;(() => {
      switch (step) {
        case EScreens.horse:
          if (isMultiHorseShown && selectedRiderMultiHorse) {
            setIsBtnNextDisabled(false)
          } else {
            setIsBtnNextDisabled(!newHorse)
          }

          break
        case EScreens.entry:
          setIsBtnNextDisabled(!selectedEntries[0])
          break

        case EScreens.teamMember:
        case EScreens.confirm:
          setIsBtnNextDisabled(false)
          break

        case EScreens.loader:
        default:
          setIsBtnNextDisabled(true)
          break
      }
    })()
  }, [step, selectedEntries, newHorse, selectedRiderMultiHorse, isMultiHorseShown])

  const getEventFromDb = useCallback(async () => {
    if (!props.dataToPassOn.rider) return toastFunctions.error({ message: 'Rider does not exist' })
    try {
      const publishedEventInDbSnapShot = await FirestoreService.getItem(
        COLLECTIONS.EVENT_REVIEW_PUBLISH.NAME,
        props.dataToPassOn.rider.eventId || ''
      )
      const publishedEventInDd = getConvertedData(
        EventReviewPublishModel.fromFirestoreDoc(publishedEventInDbSnapShot).toObject()
      )

      const _horses: IHorseData[] = []

      const allHorse = await FirestoreService.filterItems(COLLECTIONS.HORSES.NAME, [])

      allHorse.docs.forEach((doc) => {
        let data = HorseModel.fromFirestoreDoc(doc).toObject()
        _horses.push(data)
      })

      setHorses(_horses)

      const classes = props.dataToPassOn.rider.classes
      let registrationFees = getAllRegistrationFees(
        publishedEventInDd.EventFees.registrationFees || []
      )

      registrationFees = registrationFees.filter(
        (entry) => entry.name && classes.find((item) => item.registrationByDayName === entry.name)
      )

      const userInDb = await UserService.getUserById(props.dataToPassOn.rider.userId!)

      setExibitor(userInDb)
      setEntries(registrationFees)
      setEventData(publishedEventInDd)
      if (registrationFees.length === 1) {
        setSelectedEntries(registrationFees)
        setStep(EScreens.horse)
      } else {
        setStep(EScreens.entry)
      }
    } catch (error) {
      console.error('error', error)
      toastFunctions.error({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
    }
  }, [])

  useEffect(() => {
    getEventFromDb().then(() => null)
  }, [getEventFromDb])

  const entrySelectHandler = (entry: RegistrationFeesType) => {
    const _entries: RegistrationFeesType[] = [...selectedEntries]

    const index = _entries.findIndex((itm) => itm.uuid === entry.uuid)

    if (index >= 0) {
      _entries.splice(index, 1)
    } else {
      _entries.push(entry)
    }

    setSelectedEntries(_entries)
  }
  const horseSelectHandler = (item: IHorseData) => {
    let newSelectedHorse = newHorse ? { ...newHorse } : null

    if (newSelectedHorse?.id === item.id) {
      newSelectedHorse = null
    } else {
      newSelectedHorse = item
    }

    setNewHorse(newSelectedHorse)
  }

  const updateHandlerNewMember = (index: number, itm: IOption, type: THandlerMemberType) => {
    const copyNewMembers = [...newMembers]

    if (!copyNewMembers[index]) return null

    copyNewMembers[index][type] = itm

    setNewMembers(copyNewMembers)
  }

  const addHandlerNewMember = () => {
    const copyNewMembers = [...newMembers]

    copyNewMembers.push({
      member: null,
      role: null,
    })

    setNewMembers(copyNewMembers)
  }
  const removeMemberHandler = (index: number) => {
    const copyNewMembers = [...newMembers]
    copyNewMembers.splice(index, 1)
    setNewMembers(copyNewMembers)
  }
  const onSubmitSwitch = async () => {
    if (!eventData || !exibitor) {
      toastFunctions.error({ message: 'Event not found' })
      return
    }

    if (!rider?.registrationDocId) {
      toastFunctions.error({ message: 'Registration id not found' })
      return
    }

    const selectedHorse = selectedRiderMultiHorse
      ? {
          horseId: selectedRiderMultiHorse.id,
          horseName: selectedRiderMultiHorse.horseName,
          horseProfilePicture: selectedRiderMultiHorse.horseProfilePicture,
        }
      : {
          horseId: rider.horseId,
          horseName: rider.horseName,
          horseProfilePicture: rider.horseProfilePicture,
        }

    if (!selectedHorse?.horseId) {
      toastFunctions.error({ message: 'Horse not selected' })
      return
    }

    try {
      setLoading(true)

      const filteredPaperworkDocuments = getFilteredPaperwork(eventData?.EventPaperwork ?? null)

      const mailLog = filteredPaperworkDocuments.map((paperwork) => ({
        status: signedStatuses.NOT_SIGNED,
        paperworkKey: paperwork.key,
      }))

      let registrationsByDayToUpdate: IRegistrationByDayInterface[] = []

      const isMainHorse = !!rider.classes.find((item) => selectedHorse.horseId === item.horseId)?.id

      const newHorsesIds =
        isMultiHorse && selectedHorse
          ? [
              ...(rider.horsesSelected?.filter((horse) => horse.id !== selectedHorse.horseId) ??
                []),
              {
                id: newHorse?.id || '',
                name: newHorse?.horseName || '',
                picture: newHorse?.horseProfilePicture || '',
              },
            ]
          : [
              {
                id: newHorse?.id || '',
                name: newHorse?.horseName || '',
                picture: newHorse?.horseProfilePicture || '',
              },
            ]

      rider.classes.forEach((item) => {
        const hasClass = selectedEntries.find((entry) => entry.name === item.registrationByDayName)
        if (hasClass)
          registrationsByDayToUpdate.push({
            ...item,
            horseId:
              (isMultiHorse
                ? selectedHorse && isMainHorse
                  ? newHorse?.id
                  : item.horseId
                : newHorse?.id) || null,
            horseName:
              (isMultiHorse
                ? selectedHorse && isMainHorse
                  ? newHorse?.horseName
                  : item.horseName
                : newHorse?.horseName) || null,
            horseProfilePicture:
              (isMultiHorse
                ? selectedHorse && isMainHorse
                  ? newHorse?.horseProfilePicture
                  : item.horseProfilePicture
                : newHorse?.horseProfilePicture) || null,
            horsesSelected: newHorsesIds,
          })
      })

      const ridersTeamMembersToAdd: IRiderTeamMemberInterface[] = []

      const teamMembers = await RiderTeamMemberService.getByRegistrationId(rider.registrationDocId)

      const ridersTeamMembersToUpdate =
        teamMembers
          .filter(
            (item) => selectedHorse.horseId === item.horseId && rider?.riderId === item.riderId
          )
          .map((item) => ({
            ...item,
            horseId: newHorse?.id || '',
            horseName: newHorse?.horseName || '',
            horseProfilePicture: newHorse?.horseProfilePicture || '',
            mailLog: mailLog,
          })) || []

      const ids: Set<string> = new Set()
      newMembers.forEach((item) => {
        if (item.member?.value) ids.add(item.member.value)
      })
      const usersInDb = await UserService.getByIds([...ids])

      for (let newTeamMember of newMembers) {
        const user = usersInDb.find((u) => u.id === newTeamMember.member?.value)

        if (user && newTeamMember.member && newTeamMember.role) {
          for (let registrationByDayToUpdate of registrationsByDayToUpdate) {
            ridersTeamMembersToAdd.push(
              new RiderTeamMemberModel({
                userId: exibitor?.id,

                eventId: registrationByDayToUpdate.eventId,
                eventName: registrationByDayToUpdate.eventName || null,

                riderDob: registrationByDayToUpdate.riderDob,
                riderId: registrationByDayToUpdate.riderId,
                riderEmail: registrationByDayToUpdate.riderEmail,
                riderNameNGram: registrationByDayToUpdate.riderNameNGram || [],
                riderName: registrationByDayToUpdate.riderName || null,
                riderCountry: registrationByDayToUpdate.riderCountry,
                riderProfilePicture: registrationByDayToUpdate.riderProfilePicture,

                registrationDocId: registrationByDayToUpdate.registrationDocId || null,

                teamMemberId: user.id || null,
                teamMemberDob: user.userDOB || null,
                teamMemberName: getUserFullName(user),
                teamMemberRole: newTeamMember?.role?.value || '',
                teamMemberEmail: user.userEmail || null,
                teamMemberProfilePicture: user.userProfilePicture || null,

                horseId: registrationByDayToUpdate.horseId,
                horseName: registrationByDayToUpdate.horseName,
                horseProfilePicture: registrationByDayToUpdate.horseProfilePicture || null,

                mailLog,

                modified: new Date().toString(),
                created: new Date().toString(),
              }).toObject()
            )
          }
        }
      }

      await saveRidersTeamMembers({
        ridersTeamMembersToAdd,
        ridersTeamMembersToUpdate,
      })

      await saveUserDocuments({
        filteredPaperworkDocuments,
        ridersTeamMembersToAdd,
        ridersTeamMembersToUpdate,
        eventDetails: eventData.EventDetails,
        competitor: exibitor,
      })

      for (const registrationByDay of registrationsByDayToUpdate) {
        await FirestoreService.updateItem(
          COLLECTIONS.REGISTRATION_BY_DAY.NAME,
          registrationByDay.id,
          registrationByDay
        )
      }

      onSwitchHorse(registrationsByDayToUpdate)
    } catch (error) {
      console.error('error', error)
      toastFunctions.error({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
    } finally {
      setLoading(false)
    }
  }

  const renderModalBody = () => {
    switch (step) {
      case EScreens.loader:
        return (
          <>
            <ViewsLoader
              className="flex items-center w-full justify-center !h-[300px]"
              size="xl"
              color="red"
            />
          </>
        )
      case EScreens.entry:
        return (
          <SelectRiderClass
            selectedEntries={selectedEntries}
            entries={entries}
            selectHandler={entrySelectHandler}
          />
        )
      case EScreens.teamMember:
        return (
          <SetTeamMembers
            newMembers={newMembers}
            currentRider={props.dataToPassOn.rider}
            addHandlerNewMember={addHandlerNewMember}
            updateHandlerNewMember={updateHandlerNewMember}
            removeMemberHandler={removeMemberHandler}
            roles={ROLES}
          />
        )

      case EScreens.horse:
        return (
          <SelectNewHorse
            rider={props.dataToPassOn.rider}
            selectedRiderMultiHorse={selectedRiderMultiHorse}
            setSelectedRiderMultiHorse={setSelectedRiderMultiHorse}
            isMultiHorseShown={isMultiHorseShown}
            horses={horses}
            newHorse={newHorse}
            selectHandler={horseSelectHandler}
          />
        )
      case EScreens.confirm:
        return (
          <Confirm
            newHorse={newHorse!}
            selectedEntries={selectedEntries!}
            rider={props.dataToPassOn.rider}
            selectedRiderMultiHorse={selectedRiderMultiHorse}
            newTeamMembers={newMembers}
          />
        )
    }
  }

  return (
    <>
      <MainModal
        title="Switch horse"
        show={true}
        type="SWITCH_HORSE"
        size="xl"
        titleClassName="!font-normal"
        buttons={[
          {
            label: step === EScreens.confirm ? 'SWITCH horse' : 'Next >',
            fullWidth: true,
            loading,
            onClick: async () => {
              if (step === EScreens.confirm) {
                await onSubmitSwitch()
              } else if (step === EScreens.entry && isMultiHorse) {
                setStep((prev) => prev + 1)
                if (isMultiHorse) setIsMultiHorseShown(true)
              } else if (step === EScreens.horse && isMultiHorseShown) {
                setIsMultiHorseShown(false)
              } else {
                setStep((prev) => prev + 1)
              }
            },
            disabled: isBtnNextDisabled,
          },
          {
            label: 'Back',
            fullWidth: true,
            loading,
            onClick: () => {
              if (step === EScreens.horse && isMultiClasses) {
                setStep((prev) => prev - 1)
              } else if (step === EScreens.horse && isMultiHorse) {
                setIsMultiHorseShown(true)
              } else {
                setStep((prev) => prev - 1)
              }
            },
            disabled:
              (entries.length === 1 && step === EScreens.horse && isMultiHorseShown) ||
              step === EScreens.entry ||
              loading,
          },
          {
            label: 'CANCEL',
            loading,
            disabled: loading,
            bgClass: 'bg-SeabiscuitLightThemeColor',
            className: 'outline-none',
            borderClass: 'border border-transparent',
            textClass: 'text-SeabiscuitLightTextColor !w-full',
            onClick: () => props.handleModal(false, MODAL_CONSTS.SWITCH_HORSE),
          },
        ]}
      >
        <SwitchHorseHeader rider={props.dataToPassOn.rider} />

        {renderModalBody()}
      </MainModal>
    </>
  )
}
